<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' :inspectionReport.pkId > 0 ? '编辑' : '新建'"
      width="1300px"
      append-to-body
      top="2vh"
      @close="$reset('form')">
    <template>
      <el-tabs v-model="defaultTabName" style="height: 700px;">
        <el-tab-pane name="p1" label="基本信息">
          <el-form
              ref="form"
              :model="inspectionReport"
              :rules="ruleValidate"
              :disabled="disabled"
              class="form"
              label-width="80px">
            <el-row>
              <el-col :span="8">
                <el-form-item label="编号" prop="no">
                  <el-input v-model="inspectionReport.no" disabled/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="关联单据" prop="billNo">
                  <el-input v-model="inspectionReport.billNo" disabled/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="批次数量" prop="checkQuantity">
                  <el-input v-model="inspectionReport.checkQuantity" disabled/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="物料编号" prop="materialNo">
                  <el-input v-model="inspectionReport.materialNo" disabled/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="规格型号" prop="specification">
                  <el-input v-model="inspectionReport.specification" disabled/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="物料名称" prop="materialName">
                  <el-input v-model="inspectionReport.materialName" disabled/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="检验标准" prop="sampleStandard">
                  <el-select v-model="inspectionReport.sampleStandard" disabled>
                    <el-option value="GBT2828"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="检验等级" prop="checkLevel">
                  <el-select v-model="inspectionReport.checkLevel" disabled>
                    <el-option value="Ⅰ"/>
                    <el-option value="Ⅱ"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="AQL" prop="aql">
                  <el-input v-model="inspectionReport.aql" disabled/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4">
                <el-form-item label="检验数量" prop="inspectionQuantity">
                  <el-input v-model="inspectionReport.inspectionQuantity" disabled/>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="不良数量" prop="badQuality">
                  <el-input v-model="inspectionReport.badQuality"/>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="检验结果" prop="inspectionResult1">
                  <el-switch
                      v-model="inspectionReport.inspectionResult1"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      active-text="OK"
                      :active-value="true"
                      inactive-text="NG"
                      :inactive-value="false"
                      @change="resultChange"/>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="inspectionReport.templateExist===0">
                <el-form-item label="检验模板">
                  <el-select v-model="inspectionReport.inspectionTemplateId" @change="handleSelectTemplate">
                    <el-option v-for="item in templateList" :key="item.pkId" :label="item.templateName"
                               :value="item.pkId"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-form-item label="描述">
                <el-input v-model="inspectionReport.note" type="textarea" placeholder="请输入"/>
              </el-form-item>
            </el-row>
            <el-row>
              <el-table
                  height="420"
                  :data="inspectionReport.resultVOS"
                  border>
                <!--          <el-table-column prop="inspectionItemNo" width="90" label="检验编号"/>-->
                <el-table-column prop="inspectionCategory" width="60" label="类型"/>
                <el-table-column prop="inspectionItemName" width="100" label="检验名称"/>
                <el-table-column prop="inspectionStandard" label="检验标准"/>
                <el-table-column v-if="inspectionReport.pkId > 0" prop="standardValue" label="标准值"/>
                <el-table-column v-else prop="standardValue" label="标准值">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.standardValue" placeholder="请输入"/>
                  </template>
                </el-table-column>
                <el-table-column v-if="inspectionReport.pkId>0" prop="maxValue" label="最大值"/>
                <el-table-column v-else prop="maxValue" label="最大值">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.maxValue" placeholder="请输入"/>
                  </template>
                </el-table-column>
                <el-table-column v-if="inspectionReport.pkId>0" prop="minValue" label="最小值"/>
                <el-table-column v-else prop="minValue" label="最小值">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.minValue" placeholder="请输入"/>
                  </template>
                </el-table-column>
                <el-table-column prop="value1" width="90" label="检验值">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.value1" placeholder="请输入"/>
                  </template>
                </el-table-column>
                <el-table-column prop="value2" width="90" label="检验值">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.value2" placeholder="请输入"/>
                  </template>
                </el-table-column>
                <el-table-column prop="value3" width="90" label="检验值">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.value3" placeholder="请输入"/>
                  </template>
                </el-table-column>
                <el-table-column prop="value4" width="90" label="检验值">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.value4" placeholder="请输入"/>
                  </template>
                </el-table-column>
                <el-table-column prop="value5" width="90" label="检验值">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.value5" placeholder="请输入"/>
                  </template>
                </el-table-column>
                <el-table-column prop="inspectionResult" width="130" label="检验结果">
                  <template slot-scope="scope">
                    <el-switch
                        v-model="scope.row.inspectionResult"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="OK"
                        :active-value="true"
                        inactive-text="NG"
                        :inactive-value="false"
                        @change="singleResultChange"/>
                  </template>
                </el-table-column>
                <el-table-column prop="inspectionResultDesc" align="left" label="检验描述" width="120">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.inspectionResultDesc" class="note" type="textarea" placeholder="请输入"/>
                  </template>
                </el-table-column>
                <!--          <el-table-column label="操作" align="center" width="80">-->
                <!--            <template slot-scope="scope">-->
                <!--              <el-button type="danger" @click="deleteRow(scope.$index)"> 删除</el-button>-->
                <!--            </template>-->
                <!--          </el-table-column>-->
              </el-table>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane name="p2" label="附件">
          <el-form
              ref="form"
              :model="inspectionReport"
              :rules="ruleValidate"
              class="form"
              label-width="80px">
            <el-row>
              <!--        <el-divider/>-->
              <upload-file
                  ref="upload" :disabled="disabled"
                  :show-file-list="false"
                  :auth-index="192"
                  style="text-align: right;margin-top: 2px;"
                  @upload-success="uploadSuccess"/>
              <el-table :data="inspectionReport.photos" height="100" border>
                <el-table-column prop="photoPath" align="left" label="附件" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <!--              <el-input v-model="scope.row.photoPath" class="tabInput"-->
                    <!--                        style="width: 400px; margin: 0 auto; text-align: center"/>-->
                    <span>{{scope.row.photoPath}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="120" class-name="vm-table_operate">
                  <template slot-scope="scope">
                    <el-button type="primary" @click="downLoad(scope.row)">下载</el-button>
                    <el-button type="danger" @click="inspectionReport.photos.splice(scope.$index, 1)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane name="p3" label="图纸">
          <div v-if="inspectionReport.drawFilePath">
            <pdf-preview ref="pdfRead" :pdf-url="url"/>
          </div>
        </el-tab-pane>
      </el-tabs>
    </template>

    <span v-if="!disabled" slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import constants from "../../../util/constants";
  import UploadFile from "@/components/UploadFile.vue";
  import PdfPreview from "@/components/PdfPreview1";

  export default {
    name: "PurchaseReportEdit",
    components: {UploadFile, PdfPreview},
    data() {
      return {
        constants,
        templateList: [],
        dialogVisible: false,
        submitLoading: false,
        disabled: false,
        url: "",
        defaultTabName: "p1",
        inspectionReport: {
          pkId: 0,
          no: "",
          billNo: "",
          billType: 10,
          inspectionTemplateId: 0,
          inspectionTemplateName: "",
          billTypeName: "",
          materialNo: "",
          materialName: "",
          specification: "",
          note: "",
          inspectionResult1: "",
          resultVOS: [],
          photos: [],
          drawFilePath: "",
          templateExist: 1,
        },
        ruleValidate: {
          no: {required: true, message: "请输入名称", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row, mark, readOnly) {
        this.getTempList();
        this.dialogVisible = true;
        this.disabled = readOnly;
        this.url = "";
        this.defaultTabName = "p1";
        // this.inspectionReport.templateExist = 1;

        if (mark) {
          this.inspectionReport.pkId = row.pkId;
          this.getData();
          this.inspectionReport.drawFilePath = row.drawFilePath;
        } else {
          this.inspectionReport = row;
        }
        if (this.inspectionReport.drawFilePath) {
          this.loadPdf(this.inspectionReport.drawFilePath);
        }
      },

      // 根据id查询信息
      getData() {
        this.$http.get("basic", `inspectionReports/${this.inspectionReport.pkId}`).then((resp) => {
          if (resp.success) {
            this.inspectionReport = resp.data;
          }
        });
      },
      getTempList() {
        this.$http
            .get("basic", "inspectionTemplates/list/10")
            .then((resp) => {
              if (resp.success) {
                this.templateList = resp.data;
              }
            });
      },
      //加载pdf
      loadPdf(url) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(url)}`).then((res) => {
          // console.log(res);
          if (res.success) {
            this.url = res.data;
          }
        }).catch(() => {
        });
      },
      // 获取编号
      getNode() {
        this.$http.get("basic", "inspectionReports/getNo").then((resp) => {
          if (resp.success) {
            this.inspectionReport.no = resp.data;
          }
        });
      },
      handleSelectTemplate(value) {
        this.$http.get("basic", `inspectionTemplates/${value}`).then((resp) => {
          if (resp.success) {
            let vo = resp.data;
            this.inspectionReport.inspectionTemplateId = vo.pkId;
            this.inspectionReport.sampleStandard = vo.sampleStandard;
            this.inspectionReport.inspectionTemplateName = vo.templateName;
            this.inspectionReport.checkLevel = vo.checkLevel;
            this.inspectionReport.aql = vo.aql;
            this.inspectionReport.inspectionResult1 = false;
            this.inspectionReport.resultVOS = [];
            vo.details.forEach((item) => {
              let dvo = {
                "inspectionItemId": item.inspectionItemId,
                "inspectionItemName": item.inspectionItemName,
                "inspectionItemNo": item.inspectionItemNo,
                "inspectionMethod": item.inspectionMethod,
                "inspectionStandard": item.inspectionStandard,
                "inspectionCategory": item.inspectionCategory,
                "standardValue": item.standardValue,
                "maxValue": item.maxValue,
                "minValue": item.minValue,
                "inspectionNote": item.note,
                "inspectionResult": false,
              };
              this.inspectionReport.resultVOS.push(dvo);
            });
          }
        });
      },
      singleResultChange() {
        this.inspectionReport.inspectionResult1 = this.inspectionReport.resultVOS.some((item) => !item.inspectionResult) ? false : true;
      },
      resultChange() {
        this.inspectionReport.resultVOS.forEach((item) => {
          item.inspectionResult = this.inspectionReport.inspectionResult1;
        });
      },
      uploadSuccess(fileList) {
        if (fileList.length) {
          const params = {
            // fileName: fileList[0].name,
            photoPath: fileList[0].key,
          };
          this.inspectionReport.photos.push(params);
        }
      },
      // 下载
      downLoad(row) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(row.photoPath)}`).then((res) => {
          if (res.success) {
            window.open(res.data);
          }
        });
      },
      // 提交
      submit() {
        if (this.inspectionReport.pkId > 0) {
          this.handleSubmitUpdData();
        } else {
          this.handleSubmitSave();
        }
      },

      // 编辑
      handleSubmitUpdData() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
                .put("basic", "inspectionReports", this.inspectionReport)
                .then((resp) => {
                  if (resp.success) {
                    this.submitLoading = false;
                    this.dialogVisible = false;
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  }
                  this.submitLoading = false;
                })
                .catch(() => {
                  this.submitLoading = false;
                });
          }
        });
      },

      // 新建
      handleSubmitSave() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
                .post("basic", "inspectionReports/savePoReport", this.inspectionReport)
                .then((resp) => {
                  if (resp.success) {
                    this.submitLoading = false;
                    this.dialogVisible = false;
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.submitLoading = false;
                })
                .catch(() => {
                  this.submitLoading = false;
                });
          }
        });
      },
    },
  };
</script>
